export const isNumber = n => !Number.isNaN(parseFloat(n)) && Number.isFinite(n);

export const isStringNumber = n => {
  const float = parseFloat(n);
  return !Number.isNaN(float) && Number.isFinite(float);
};
